<header>
    <div>
        <h2>Transactions</h2>
        <p class="subtitle">Raw bank feed view for imported transactions before bookkeeping curation.</p>
    </div>
</header>

<div class="tabs">
    <div class="left">
        <ng-container *ngIf="dateMode != DateMode.Custom">
            <button [disabled]="isPreviousDateRangeDisabled()" mat-button (click)="previousDateRange()">{{getLabel()[0]}}</button>
            <button *ngIf="dateOffset > 0" mat-button (click)="nextDateRange()">{{getLabel()[1]}}</button>
        </ng-container>
        <ng-container *ngIf="dateMode == DateMode.Custom">
            <button mat-button (click)="cancelCustom()">Cancel</button>
        </ng-container>
    </div>

    <div class="center">
        <button mat-button [matMenuTriggerFor]="directionMenu">{{ getTransactionDirectionFilterLabel() }}</button>
        <mat-menu #directionMenu="matMenu">
            <button mat-menu-item (click)="setTransactionDirectionFilter('all')">All transactions</button>
            <button mat-menu-item (click)="setTransactionDirectionFilter('debits')">Debits</button>
            <button mat-menu-item (click)="setTransactionDirectionFilter('credits')">Credits</button>
        </mat-menu>
    </div>

    <div class="date-range-colume">
        <button mat-button [matMenuTriggerFor]="menu">{{dateRange.start | date}} to {{dateRange.end | date}}</button>
        <mat-menu #menu="matMenu">
            <button (click)="switchToWeekly()" mat-menu-item>Weekly</button>
            <button (click)="switchToMonthly()" mat-menu-item>Monthly</button>
            <button (click)="switchToQuaterly()" mat-menu-item>Quaterly</button>
            <button (click)="switchToYearly()" mat-menu-item>Yearly</button>
            <button (click)="switchToAllTime()" mat-menu-item>All Time</button>
        </mat-menu>
    </div>
</div>

<div class="container">

    <div class="left">
        <button [class.active]="activeAccount==summaryTab" (click)="switchCategory(summaryTab)" mat-button>Summary</button>
        <ng-container *ngFor="let account of accounts">
            <button [title]="account.name" [class.active]="activeAccount==account.accountNumber" (click)="switchCategory(account.accountNumber)" mat-button>{{account.name}}</button>
        </ng-container>
    </div>


    <div class="right transactionPanel">

        <div class="stats" *ngIf="activeAccount!=summaryTab">
            <div>
                Viewing
                <p>{{info.count}}</p>
            </div>
            <div>
                Credits
                <p>{{info.credits | human}}<br></p>
            </div>
            <div>
                Debits
                <p>{{info.debits | human}}</p>
            </div>
            <div>
                GST
                <p>{{info.vat | human}}</p>
            </div>
        </div>
        <div class="summary-panel" *ngIf="activeAccount==summaryTab">
            <div class="summary-hero">
                <div>
                    <p class="eyebrow">Date range</p>
                    <h2>Transaction summary</h2>
                    <p>Total debits and credits for {{ dateRange.start | date }} to {{ dateRange.end | date }}.</p>
                </div>
                <div class="period-card">
                    <span>Transactions</span>
                    <strong>{{info.count}}</strong>
                </div>
            </div>

            <div class="summary-table">
                <div class="summary-row header">
                    <div>Type</div>
                    <div class="align-right">Total</div>
                </div>
                <div class="summary-row">
                    <div>Total credits</div>
                    <div class="align-right">{{info.credits | human:true}}</div>
                </div>
                <div class="summary-row">
                    <div>Total debits</div>
                    <div class="align-right">{{info.debits | human:true}}</div>
                </div>
                <div class="summary-row summary-total">
                    <div>Net movement</div>
                    <div class="align-right">{{info.total | human:true}}</div>
                </div>
            </div>

            <div class="statement-section">
                <div class="section-heading">
                    <div>
                        <h3>Bank statement checks</h3>
                        <p>Upload each bank CSV export to fill statement totals, then check the variance.</p>
                    </div>
                    <span class="save-message" *ngIf="statementSaveMessage">{{ statementSaveMessage }}</span>
                </div>

                <div class="statement-table" *ngIf="!isLoadingStatementSummary">
                    <div class="statement-row header">
                        <span>Account</span>
                        <span class="align-right">Imported credits</span>
                        <span class="align-right">Statement credits</span>
                        <span class="align-right">Credit variance</span>
                        <span class="align-right">Imported debits</span>
                        <span class="align-right">Statement debits</span>
                        <span class="align-right">Debit variance</span>
                        <span class="align-right">Statement</span>
                    </div>
                    <div class="statement-row" *ngFor="let row of statementRows" [class.matched]="isStatementRowMatched(row)">
                        <strong>{{ row.accountName }}</strong>
                        <span class="align-right">{{ row.currentCredits | human:true }}</span>
                        <ap-money [outline]="true" [amount]="row.totalCreditsReported" (amountChange)="updateStatementAmount(row, 'totalCreditsReported', $event)"></ap-money>
                        <strong class="align-right">{{ getCreditVariance(row) | human:true }}</strong>
                        <span class="align-right">{{ row.currentDebits * -1 | human:true }}</span>
                        <ap-money [outline]="true" [amount]="row.totalDebitsReported" (amountChange)="updateStatementAmount(row, 'totalDebitsReported', $event)"></ap-money>
                        <strong class="align-right">{{ getDebitVariance(row) | human:true }}</strong>
                        <div class="statement-actions">
                            <a *ngIf="row.statement" [href]="getStatementUrl(row.statement)" target="_blank" rel="noopener">Open</a>
                            <input #statementInput type="file" accept=".csv,text/csv" hidden (change)="uploadStatementCsv($event, row)">
                            <button type="button" mat-stroked-button (click)="statementInput.click()" [disabled]="uploadingStatementAccount !== ''">
                                {{ uploadingStatementAccount === row.accountNumber ? 'Uploading...' : row.statement ? 'Replace' : 'Upload' }}
                            </button>
                        </div>
                    </div>
                </div>

                <div class="no-records" *ngIf="isLoadingStatementSummary">Loading statement checks...</div>
            </div>
        </div>

        <div class="no-records" *ngIf="activeAccount!=summaryTab && dataSource.data.length === 0">
            No transactions found for this account and date range.
        </div>

        <div class="bank-table-scroll" *ngIf="activeAccount!=summaryTab">
        <table class="transactions" *ngIf="activeAccount!=summaryTab" mat-table [dataSource]="dataSource" multiTemplateDataRows>

            <ng-container matColumnDef="date">
                <th class="date" mat-header-cell *matHeaderCellDef>Date</th>
                <td class="date" mat-cell *matCellDef="let element"> {{element['date'] | date:'dd/MM/yyyy'}} </td>
            </ng-container>
        
            <ng-container matColumnDef="description">
                <th class="description" mat-header-cell *matHeaderCellDef>Description</th>
                <td mat-cell *matCellDef="let element">
                    <div class="description-cell">
                        <div class="description-meta" *ngIf="element.additional?.curatedDescription?.details?.length">
                            {{ element.additional.curatedDescription.details.join(' ') }}
                        </div>
                        <div class="description-main">
                            <span class="customer" *ngIf="element['customer']">{{element['customer']}}</span>
                            <span>{{element.additional?.curatedDescription?.headline || element['description']}}</span>
                            <span class="note" *ngIf="element['note']">{{element['note']}}</span>
                        </div>
                    </div>
                </td>
            </ng-container>
        
            <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef>Transaction type</th>
                <td mat-cell *matCellDef="let element">{{ element.additional?.bankType }}</td>
            </ng-container>

            <ng-container matColumnDef="debit">
                <th class="amount" mat-header-cell *matHeaderCellDef>Debit</th>
                <td class="amount" mat-cell *matCellDef="let element">
                    <ng-container *ngIf="element.amount < 0">{{ -element.amount | human }}</ng-container>
                </td>
            </ng-container>

            <ng-container matColumnDef="credit">
                <th class="amount" mat-header-cell *matHeaderCellDef>Credit</th>
                <td class="amount" mat-cell *matCellDef="let element">
                    <ng-container *ngIf="element.amount >= 0">{{ element.amount | human }}</ng-container>
                </td>
            </ng-container>

            <ng-container matColumnDef="balance">
                <th class="amount" mat-header-cell *matHeaderCellDef>Balance</th>
                <td class="amount" mat-cell *matCellDef="let element">
                    <ng-container *ngIf="element.additional?.bankBalance !== null; else noBalance">{{ element.additional.bankBalance | human }}</ng-container>
                    <ng-template #noBalance><span title="Balance unavailable in bank import">�</span></ng-template>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
            <tr class="transaction-row"
                [class.missing-from-uploaded-statement]="element.additional?.missingFromUploadedStatement"
                mat-row
                (click)="openProofViewer(element, i, dataSource)"
                *matRowDef="let element; let i = dataIndex; columns: columnsToDisplay;">
            </tr>
        </table>
        </div>

        <div class="missing-statement-section" *ngIf="activeAccount!=summaryTab && missingStatementTransactions.length > 0">
            <div class="section-heading">
                <div>
                    <h3>CSV transactions missing from ledger</h3>
                    <p>These rows are in the uploaded CSV but not in the transaction ledger for this account.</p>
                </div>
            </div>

            <div class="missing-statement-table">
                <div class="missing-statement-row header">
                    <span>Date</span>
                    <span>Description</span>
                    <span class="align-right">Amount</span>
                    <span class="align-right">Balance</span>
                    <span></span>
                </div>
                <div class="missing-statement-row" *ngFor="let row of missingStatementTransactions">
                    <span>{{ getStatementRowDate(row) | date:'dd-MM-yy' }}</span>
                    <span>{{ row.description }}</span>
                    <span class="align-right">{{ row.amount | human:true }}</span>
                    <span class="align-right">{{ row.balance | human:true }}</span>
                    <span class="align-right">
                        <button mat-stroked-button color="primary" (click)="addMissingStatementTransaction(row)" [disabled]="row.isAdding">
                            {{ row.isAdding ? 'Adding...' : 'Add' }}
                        </button>
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>
